export default __webpack_public_path__ + "static/media/motherEleven.b9b32bd0.jpeg";